import { IApplicationState, TCardId } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getGanttContextHintsCardId = (
    state: IApplicationState
): TCardId => {
    return getAsidePanel(state).ganttContextCardId;
};
